<template>
  <modal-template v-if="readyToShow">
    <template #header>
      <div class="modal-header-style">
        <div style="float:left;padding-left:1%;padding-top:1%;font-weight:bold;font-size:larger;font-style:italic;">
          <span>submitted orders</span>
        </div>
        <div style="float:right;">
          <label class="action-icon-style" v-on:click="$emit('close', true)">
            <font-awesome-icon icon="xmark" size="xl"/>
            <span style="display: block;">close</span>
          </label>
        </div>
      </div>
      <div style="width:100%;float:left;">
        <div style="font-size:larger;font-weight:bold;"><sup>[{{ account.customerId }}]</sup> {{ account.customerName }}
        </div>
        <div>serviced by <sup>[{{ account.dairyId }}]</sup> {{ account.dairyName }}</div>
      </div>
    </template>
    <template #body>
      <cancel v-if="cancel"
              :dairy-id="account.dairyId"
              :dairy-name="account.dairyName"
              :customer-id="account.customerId"
              :customer-name="account.customerName"
              :order="orderToCancel"
              :username="username"
              @apierror="setApiError"
              @apierrortext="setApiErrorText"
              @close="closeCancel">
      </cancel>
      <compose-order v-if="displayCompose"
                     :account="account"
                     :username="username"
                     :iscopy="isCopy"
                     :productstocopy="productsToCopy"
                     @apierror="setApiError"
                     @apierrortext="setApiErrorText"
                     @close="closeComposeOrder">
      </compose-order>
      <div>
        <div class="table-container" style="width:100%;">
          <table>
            <thead>
            <tr>
              <th style="width:5%;"></th>
              <th style="width:10%;">deliver by</th>
              <th style="width:10%;text-align:center;">products</th>
              <th style="width:30%;text-align:left;">submitted</th>
              <th colspan="2" style="width:25%;text-align:right;">
                <div style="float:right;">
                  <label class="order-icon-style"
                         :class="role === 'super_Admin' ? 'disabled-order-icon-style':'order-icon-style'"
                         v-on:click="openComposeOrder">
                    <font-awesome-icon icon="cart-plus" text-align="left" size="xl"/>
                    <span style="display: block;">add</span>
                  </label>
                </div>
              </th>
            </tr>
            </thead>
            <template v-if="orders.length === 0">
              <tr style="font-weight:bold;font-style:italic;">
                <td colspan="5" style="text-align:center;"><span>No order history available</span></td>
              </tr>
            </template>
            <template v-for="order in orders" :key="order.orderId">
              <tr>
                <td style="text-align:left;">
                  <font-awesome-icon
                      :icon="(order === selectedOrder) ? 'circle-chevron-down' : 'circle-chevron-right'"
                      size="xl"
                      v-on:click="drillDown(order)"/>
                </td>
                <td>
                  <span style="font-weight:bold;">{{ order.formattedDate }}</span><br/>
                  <span v-if="order.purchaseOrder.trim() !==''"
                        style="font-weight:bold;font-style:italic;">po# {{ order.purchaseOrder }}
                  </span>
                </td>
                <td style="width:10%;text-align:center;">{{ order.products.length }}</td>
                <td :class="order.cancelled ? 'order-cancelled-stamp' : ''"
                    style="width:30%;text-align:left;font-weight:bold;">
                  <div style="float:left;width:100%;">on {{ new Date(order.placedOn).toLocaleString() }}</div>
                  <div style="float:left;width:100%;font-size:smaller;font-style:italic;">by {{ order.placedBy }}</div>
                </td>
                <td colspan="2" style="text-align:center;">
                  <div>
                    <label
                        :class="(role === 'super_Admin') || (order.cancelled) || (new Date() >= new Date(order.cutOff)) ? 'disabled-order-icon-style':'order-icon-style'"
                        v-on:click="(role !== 'super_Admin') && (!order.cancelled) && (new Date() < new Date(order.cutOff)) ? showCancel(order) : {}">
                      <font-awesome-icon icon="circle-xmark" text-align="left" size="xl"/>
                      <span style="display: block;">cancel</span>
                    </label>
                    <label
                        :class="(role === 'super_Admin') || order.noOrder ? 'disabled-order-icon-style':'order-icon-style'"
                        v-on:click="!order.noOrder ? copyOrder(order) : {}">
                      <font-awesome-icon icon="copy" size="xl"/>
                      <span style="display: block;">copy</span>
                    </label>
                    <label class="order-icon-style" v-on:click="generateOrderPDF(order)">
                      <font-awesome-icon icon="print" size="xl"/>
                      <span style="display: block;">print</span>
                    </label>
                  </div>
                </td>
              </tr>
              <tr v-if="orderTableRow.includes(order)" style="width:100%;">
                <td colspan="4" style="width:100%">
                  <div class="table-container" style="max-height: 250px;background:lemonchiffon;">
                    <table style="border-collapse:collapse;">
                      <thead style="z-index:1;">
                      <tr>
                        <th style="z-index:1;width:55%;text-align:left;">product</th>
                        <th style="z-index:1;width:15%;">
                          <div v-if="dairy.bypassOrderEntry">case qty</div>
                          <div v-else>units per</div>
                        </th>
                        <th style="z-index:1;width:15%;">packaging</th>
                        <th style="z-index:1;width:15%;">units</th>
                        <th v-if="dairy.showPrice">price per</th>
                      </tr>
                      </thead>
                      <template v-for="product in selectedOrder.products" :key="product"
                                style="border:none;">
                        <tr>
                          <td style="width:55%;">
                            <sup>[{{ product.id }}]</sup>&nbsp;<span
                              style="font-weight:bold;">{{ product.name }}</span>
                          </td>
                          <td style="width:15%;text-align:center;">
                            {{ product.packText ? product.packText : product.unitsPerPackaging }}
                          </td>
                          <td style="width:15%;text-align:center;">
                            <div class="review">{{ product.packagings === 0 ? "" : product.packagings }}</div>
                          </td>
                          <td style="width:15%;text-align:center;">
                            <div class="review">{{ product.units === 0 ? "" : product.units }}</div>
                          </td>
                          <td v-if="dairy.showPrice" style="text-align:right;">{{
                              product.pricePer.toLocaleString(
                                  'en-US', {
                                    style: 'currency',
                                    currency: 'USD',
                                    minimumFractionDigits: 4
                                  }
                              )
                            }}
                          </td>
                        </tr>
                      </template>
                      <tfoot>
                      <tr>
                        <th colspan="5" style="text-align:right;">
                          <order-total
                              :dairy="dairy"
                              :products="displayedProducts"
                              :columns="4"
                          />
                        </th>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </td>
              </tr>
            </template>
          </table>
        </div>
      </div>
    </template>
    <template #footer>
    </template>
  </modal-template>
</template>

<script>
import OrderTotal from '@/components/ordering/OrderTotal'
import Cancel from '@/components/ordering/Cancel'
import ComposeOrder from '@/components/ordering/Compose'
import ModalTemplate from '@/components/ModalTemplate'
import {orderTotalMixin} from '@/mixins/OrderTotalMixin'
import {jsPDF} from 'jspdf'
import 'jspdf-autotable'

export default {
  name: 'List',
  mixins: [orderTotalMixin],
  components: {
    OrderTotal,
    Cancel,
    ModalTemplate,
    ComposeOrder,
  },
  props: ['account', 'username', 'role'],
  emits: ['close', 'apierror', 'apierrortext'],
  data: function () {
    return {
      readyToShow: false,
      orders: [],
      orderTableRow: [],
      selectedOrder: {},
      cancel: false,
      orderToCancel: {},
      displayedProducts: [],
      displayCompose: false,
      isCopy: false,
      productsToCopy: [],
      dairy: {},
    }
  },
  methods: {
    getOrders() {
      this.readyToShow = false

      this.axios
          .get('orders/list', {
            params: {
              dairyId: this.account.dairyId,
              accountId: this.account.customerId,
            }
          })
          .then(response => {
            response.data.forEach(order => {
              order.formattedDate =
                  order.deliveryDate.substring(5, 7) + '/' +
                  order.deliveryDate.substring(8, 10) + '/' +
                  order.deliveryDate.substring(0, 4)
            })

            this.orders = _.orderBy(response.data, ['deliveryDate'], ['desc'])
          })
          .catch(error => {
            this.setApiError(true)
            this.setApiErrorText(error.response.statusText)
          })
          .finally(() => {
            this.readyToShow = true
          })
    },
    drillDown(order) {
      this.axios
          .get('orders/dairy/get', {
            params: {
              dairyId: this.account.dairyId,
            }
          })
          .then(response => {
            this.dairy = response.data;

            this.orderTableRow = []
            this.displayedProducts = []

            if (this.selectedOrder === order) {
              this.selectedOrder = {}
              this.displayedProducts = []
            } else {
              order.products = _.sortBy(order.products, ['sortSequence'])
              this.selectedOrder = order
              this.displayedProducts = this.selectedOrder.products
              this.orderTableRow.push(this.selectedOrder)
            }
          })
          .catch(error => {
            this.setApiError(true)
            this.setApiErrorText(error.response.statusText)
          })
          .finally(() => {
            this.readyToShow = true
          })
    },
    openComposeOrder: function () {
      if (this.role !== 'super_Admin') {
        this.isCopy = false
        this.productsToCopy = []
        this.displayCompose = true
      }
    },
    closeComposeOrder: function () {
      this.selectedAccount = {}
      this.displayCompose = false
      this.getOrders()
    },
    showCancel: function (order) {
      if (this.role !== 'super_Admin') {
        this.orderToCancel = order
        this.cancel = true
      }
    },
    closeCancel: function () {
      this.orderToCancel = {}
      this.cancel = false
      this.getOrders()
    },
    setApiError: function (isError) {
      this.$emit('apierror', isError)
    },
    setApiErrorText: function (text) {
      this.$emit('apierrortext', text)
    },
    copyOrder: function (order) {
      if (this.role !== 'super_Admin') {
        this.isCopy = true
        this.productsToCopy = order.products
        this.displayCompose = true
      }
    },
    generateOrderPDF: function (order) {
      this.axios
          .get('orders/dairy/get', {
            params: {
              dairyId: this.account.dairyId,
            }
          })
          .then(response => {
            this.dairy = response.data

            const productRows = []

            for (const product of order.products) {
              productRows.push(
                  [
                    {content: '[' + product.id + '] ' + product.name.replace(/\s+/g, ' ')},
                    {content: product.unitsPerPackaging.toString().padStart(8, ' ')},
                    {content: product.packagings === 0 ? '' : product.packagings.toString().padStart(8, ' ')},
                    {content: product.units === 0 ? '' : product.units.toString().padStart(8, ' ')},
                    {
                      content: this.dairy.showPrice ? product.pricePer.toLocaleString(
                          'en-US', {
                            style: 'currency',
                            currency: 'USD',
                            minimumFractionDigits: 4
                          }
                      ) : ''
                    }
                  ]
              )
            }

            const pdfDocument = new jsPDF({
              orientation: 'p',
              format: 'letter',
              compress: true,
              lineHeight: 1,
              autoSize: false,
              printHeaders: true
            })

            pdfDocument.setProperties(
                {
                  title: 'Order',
                  subject: 'for [' + this.account.customerId + '] ' + this.account.customerName.replace(/\s+/g, ' '),
                  author: 'Prairie Farms Dairy',
                  keywords: 'order, orders, list',
                  creator: 'Prairie Farms Dairy'
                }
            )

            pdfDocument.autoTable({
              theme: 'striped',
              head: [
                [{
                  colSpan: this.dairy.showPrice ? 5 : 4,
                  content: 'Order placed for [' + this.account.customerId + '] ' + this.account.customerName.replace(/\s+/g, ' '),
                }],
                [{
                  colSpan: this.dairy.showPrice ? 5 : 4,
                  content: 'serviced by: [' + this.account.dairyId + '] ' + this.account.dairyName.replace(/\s+/g, ' ') +
                      '\r\n   deliver by: ' + new Date(order.deliveryDate + 'T12:00:00.000Z').toLocaleDateString() +
                      '\r\n             po#: ' + order.purchaseOrder +
                      '\r\n        placed: ' + new Date(order.placedOn).toLocaleDateString() + ' at ' + new Date(order.placedOn).toLocaleTimeString() + ' by ' + order.placedBy,
                }],
                ['product', 'units per', 'packaging', 'units',
                  this.dairy.showPrice ? 'price per' : ''
                ]
              ],
              bodyStyles: {
                fontSize: 12
              },
              body: productRows,
              foot: [
                [{
                  content: this.unitTotal(order.products) + ' units, or ' +
                      this.packagingTotal(order.products) +
                      ' (est.) total packagings ' +
                      (this.dairy.showPrice ? 'totaling ' + this.orderPriceTotal(order.products) : ''),
                  colSpan: this.dairy.showPrice ? 5 : 4,
                  styles: {halign: 'center', fontSize: '14'}
                }],
              ]
            })

            const pageCount = pdfDocument.internal.getNumberOfPages()

            for (let i = 0; i < pageCount; i++) {
              pdfDocument.setPage(i)
                  .setFontSize(10)
                  .setFont(undefined, 'bold')
                  .setTextColor(255, 255, 255)

              const pageCurrent = pdfDocument.internal.getCurrentPageInfo().pageNumber

              pdfDocument.text('page ' + pageCurrent + ' of ' + pageCount, 180, 19)

              if (order.noOrder) pdfDocument.text('***   THIS IS  A NO ORDER   ***', 140, 23)

              if (order.cancelled) pdfDocument.text('*** THIS ORDER IS CANCELLED ***', 140, 27)
            }

            setTimeout(() => {
              window.open(URL.createObjectURL(pdfDocument.output('blob')), '_blank')
            })
          })
          .catch(error => {
            this.setApiError(true)
            this.setApiErrorText(error.response.statusText)
          })
    },
  },
  mounted() {
    this.getOrders()
  },
}
</script>

<style scoped>
.modal-header-style {
  width: 100%;
  float: left;
  background: black;
  color: white;
  border-radius: 4px;
}

.action-icon-style {
  color: white;
  text-align: center;
  cursor: pointer;
  width: 80px;
}

.action-icon-style:hover {
  font-weight: bolder;
}

.order-icon-style {
  color: black;
  text-align: center;
  cursor: pointer;
  width: 80px;
}

.order-icon-style:hover {
  font-weight: bolder;
}

.disabled-order-icon-style {
  color: grey;
  text-align: center;
  cursor: pointer;
  width: 80px;
}
</style>
